<template>
    <div
        class="d-flex flex-wrap justify-content-between w-100 cursor-pointer"
        @click="goToFeedbacks"
    >
        <SummaryBox
            icon="fa fa-arrow-up"
            :info="sentFeedbacks"
            :title="$t('profile.feedback.sent')"
        />
        <SummaryBox
            icon="fa fa-arrow-down"
            :info="receivedFeedbacks"
            :title="$t('profile.feedback.received')"
        />
        <SummaryBox
            icon="fa fa-sign-out"
            :info="requestedFeedbacks"
            :title="$t('profile.feedback.requested')"
        />
        <SummaryBox
            :info="pendingFeedbacks"
            icon="fa fa-exclamation-circle"
            :title="$t('profile.feedback.pending')"
        />
    </div>
</template>

<script>
import { EventBuzz } from '@/main'
import { getFeedbacksSummary } from './api'
import { SummaryBox } from '../components'

export default {
    components: {
        SummaryBox,
    },
    props: {
        userId: {
            type: [String, Number],
            required: true,
        },
        periods: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            sentFeedbacks: 0,
            pendingFeedbacks: 0,
            receivedFeedbacks: 0,
            requestedFeedbacks: 0,
        }
    },
    watch: {
        userId() {
            this.getFeedbacksSummaryFromApi()
        },
        periods() {
            this.getFeedbacksSummaryFromApi()
        },
    },
    mounted() {
        EventBuzz.$on('update-talk-summary', this.getFeedbacksSummaryFromApi)
        this.getFeedbacksSummaryFromApi()
    },
    methods: {
        getFeedbacksSummaryFromApi() {
            getFeedbacksSummary(this.userId, this.periods).then(res => {
                this.sentFeedbacks = res.sent
                this.pendingFeedbacks = res.pending
                this.receivedFeedbacks = res.received
                this.requestedFeedbacks = res.requested
            })
        },
        goToFeedbacks() {
            this.$router.push('/v2/feedbacks')
        },
    },
}
</script>
